import { ButtonProps, IconProps, modal } from 'bold-ui'
import { ModalDepthLevel } from 'bold-ui/lib/components/Modal/Modal'
import { ModalBody } from 'components/modals/ModalBody'
import React from 'react'

export interface ConfirmConfig {
  title: React.ReactNode
  body?: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  type?: ButtonProps['kind']
  onCancel?(e: React.SyntheticEvent): any
  onClose?(): any
  onConfirm?(e: React.SyntheticEvent): any
  depthLevel?: ModalDepthLevel
  manageOverflow?: boolean
}

const defaultConfig: ConfirmConfig = {
  body: null,
  title: 'Confirmação',
  cancelLabel: 'Cancelar',
  confirmLabel: 'Confirmar',
  type: 'primary',
  onCancel: () => null,
  onConfirm: () => null,
}

const icons: { [key in ButtonProps['kind']]: IconProps['icon'] } = {
  normal: 'questionMarkOutline',
  primary: 'questionMarkOutline',
  danger: 'exclamationTriangleOutline',
}

export const confirm = (config: ConfirmConfig) => {
  const { title, body, onCancel, onConfirm, confirmLabel, cancelLabel, type, onClose, depthLevel, manageOverflow } = {
    ...defaultConfig,
    ...config,
  }

  return modal({
    size: 'small',
    onClose,
    render: () => (
      <ModalBody title={title} icon={icons[type]} type={type}>
        {body}
      </ModalBody>
    ),
    depthLevel,
    manageOverflow,
    actions: [
      { label: cancelLabel, onClick: onCancel },
      { label: confirmLabel, kind: type, onClick: onConfirm },
    ],
  })
}
